import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";
export var renderStatisticsIcon = function (hasStatistics, statisticsTooltip, statHandler) {
    return (hasStatistics
        ? React.createElement(EventCardIcon, { className: "rj-ev-list__ev-card-icon--tooltip rj-ev-list__ev-card-icon--hidden-on-mobile", tooltip: statisticsTooltip, onClick: statHandler },
            React.createElement(Icon, { i: "i-24-16 i-o-ev-statistics" }))
        : createEmptyTooltipIcon());
};
//# sourceMappingURL=renderStatisticsIcon.js.map